// ponytail: the demo removed by D022 left a fake session (userId=1…) in visitors'
// browsers, which made /signup say "already signed in". Delete this file once
// that release has been live for a few months.
const LEGACY_DEMO_KEYS = ['demoMode', 'demoTier', 'userId', 'teams_and_competences', 'selected_team', 'team_features_1'];

export function clearLegacyDemo(): void {
  try {
    if (localStorage.getItem('demoMode') !== 'true') return;
    LEGACY_DEMO_KEYS.forEach(k => localStorage.removeItem(k));
    document.cookie = 'user_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'userId=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  } catch {}
}
